module.exports = __webpack_public_path__ + "img/building-2.9cef1ac4.png";